<template>
    <UContainer class="my-4 lg:my-8">
        <div class="my-4">
            <UBreadcrumb :links="breadcrumb">
                <template #icon="{ link }">
                    <UtilsDynamicIcon v-if="link.icon" :icon="link.icon" class-name="w-5 h-5 mx-1 -mt-0.5" />
                </template>
            </UBreadcrumb>
        </div>
        <div class="flex max-md:flex-col items-start relative">
            <div class="w-full max-md:mt-6 md:grid md:grid-cols-3 gap-6">
                <WidgetsProductCard
                    class="max-md:mt-6"
                    :is-loading="status === 'pending'"
                    :eager="index < 3"
                    v-for="(item, index) in products?.data"
                    :key="item.id || index"
                    :product="item"
                />
            </div>
        </div>
    </UContainer>
</template>

<script lang="ts" setup>
import type { IResponse } from "~/libs/types/api/pagination";
import type { IProduct } from "~/libs/types/api/product";
import type { BreadcrumbLink } from "#ui/types";

const { t } = useI18n();

useSeoMeta({
    title: "پرفروش‌ترین محصولات قهوه | فروشگاه نرس‌لند",
    description: "لیست پرفروش‌ترین و محبوب‌ترین دانه‌ها و پودرهای قهوه تخصصی و ترکیبی نرس‌لند با بیشترین رضایت مشتریان.",
    canonical: "https://northland-co.com/product/best-sellers",
    ogTitle: "پرفروش‌ترین محصولات قهوه نرس‌لند",
    ogDescription: "محبوب‌ترین و پرفروش‌ترین قهوه‌های تخصصی و ترکیبی رستری نرس‌لند.",
    ogType: "website",
    ogUrl: "https://northland-co.com/product/best-sellers",
    robots: "index, follow",
});

useSchemaOrg([
    defineBreadcrumb({
        itemListElement: [
            { name: "خانه", item: "/" },
            { name: "پرفروش‌ترین‌ها", item: "https://northland-co.com/product/best-sellers" },
        ],
    }),
]);

defineOgImageComponent("Main", {
    title: "پرفروش‌ترین محصولات قهوه",
    description: "محبوب‌ترین و پرفروش‌ترین دانه‌های قهوه نرس‌لند",
    path: "/product/best-sellers",
});

const {
    data: products,
    status,
    error,
    refresh,
} = await useAsyncData<IResponse<IProduct[]>>("best-sellers-products", () =>
    fetchData("/products/get/best-sellers"),
    {
        getCachedData(key, nuxtApp) {
            return nuxtApp.payload.data[key] || nuxtApp.static.data[key];
        },
    }
);

const breadcrumb: ComputedRef<BreadcrumbLink[]> = computed(() => {
    return [
        {
            icon: "i-solar-home-angle-line-duotone",
            label: "",
            to: "/",
        },
        {
            label: t("best_sellers"),
            icon: "i-solar-layers-minimalistic-line-duotone",
        },
    ];
});
</script>

<style></style>
